import { service, createService } from '@/common/request/request.js'
// export function testcreateService(data = {}) { // createService 使用示例
//   return createService('https://test.com/')({ url: 'createService', method: 'post', data })
// }

// 第三方授权登录：Google、Twitter、Facebook
export function thirAuthLogin(data = {}) {
  return service({
    url: '/guest/thirAuthLogin',
    method: 'post',
    data
  })
}

// 注册
export function register(data = {}, type = 0) { // type 0 默认 1 多彩宝
  const urls = ['/guest/registered', '/guest/registeredNew']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 自定义注册项
export function queryRegisterItem(data = {}) {
  return service({
    url: '/guest/queryRegisterItem',
    method: 'post',
    data
  })
}

// 新注册页接口
export function registeredphone(data = {}) {
  return service({
    url: '/guest/registeredphone',
    method: 'post',
    data
  })
}

// 登录
export function login(data = {}) {
  return service({
    url: '/login',
    method: 'post',
    data
  })
}

// 退出登录
export function logout(data = {}) {
  return service({
    url: '/loged/logout',
    method: 'post',
    data
  })
}

// 返回所有一级页面需要的用户信息
export function getUserInfo(data = {}, type = 0) {
  // 0 刷新用户信息使用 1 登录使用
  const url = ['/loged/firstUserInfo', '/loged/logedUserInfo']
  return service({
    url: url[type],
    method: 'post',
    data
  })
}

// 刷新用户信息
export function refreshUserInfo(data = {}) {
  return service({
    url: '/loged/refreshUserInfo',
    method: 'post',
    data
  })
}

// 获取验证码图片
export function getPictureCode(params = {}) {
  // return service({
  //   url: '/guest/defaultKaptcha',
  //   method: 'get',
  //   params
  // })
  return '/api/guest/defaultKaptcha'
}

// 登录状态-修改登录密码
export function updateLoginPassword(data = {}) {
  return service({
    url: '/loged/updateLoginPassword',
    method: 'post',
    data
  })
}

// 未登录-忘记密码功能：第二步，输入账号、手机/邮箱，加类型，验证码，密码，确认密码
export function forgetPassword(data = {}) {
  return service({
    url: '/guest/forget/confirm',
    method: 'post',
    data
  })
}

// 忘记密码功能：第一步，输入账号、手机/邮箱，加类型，发送验证码
export function sendCode(data = {}, type = 0) { // type 0 默认 1 多彩宝
  const urls = ['/guest/forget/sendCode', '/guest/forget/sendCodeNew']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 发送手机登录验证码
export function sendLoginCode(data = {}) {
  return service({
    url: '/guest/lottery/login/sendVerifictionCode',
    method: 'post',
    data
  })
}

// 获取注册用户是否为代理注册
export function queryAgentBonus(data = {}) {
  return service({
    url: '/register/queryAgentBonus',
    method: 'post',
    data
  })
}

// 游客获取服务器信息
export function initSystem(data = {}) {
  return service({
    url: '/init',
    method: 'post',
    data
  })
}

export function getFrontConfig(data = {}, type = 1) {
  // 0 365代理联系方式 1 365所有代理联系方式
  const urls = ['/guest/frontConfig/getFrontConfig', '/guest/frontConfig/getFrontConfig/list']
  return service({
    url: urls[type],
    method: 'post',
    data
  })
}

// 获取用户设备信息
export function getDeviceInfo(data = {}) {
  return service({
    url: '/loged/deviceInfo',
    method: 'post',
    data
  })
}

// 刷新token过期时间，并刷新用户在游戏中的余额
export function refresh(data = {}) {
  return service({
    url: '/loged/refresh',
    method: 'post',
    data
  })
}

// 账户刷新
export function refreshGameAccount(data = {}) {
  return service({
    url: '/loged/refreshGameAccount',
    method: 'post',
    data
  })
}

// 用户注册通过手机发送验证码，发送验证码
export function registerPhoneCode(data = {}) {
  return service({
    url: '/guest/phone/sendVerify',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/system.js